import './LoadingView.css';

export default function LoadingView() {
    return <table className="LoadingView">
        <tbody>
            <tr>
                <td>
                    <img src="./loading-transparent.gif" alt="loading ..."/>
                </td>
            </tr>
        </tbody>
    </table>
}